'use client';

import { LinkButton } from '@/src/shared/presentation/components/link-button';

import { CMSBlockTitle } from '../cms-block-title';
import { CMSBlockWrapper } from '../cms-block-wrapper';

import css from './partnership-banner-block-view.css';

import type { PartnershipBannerBlockViewModel } from '../../view-models/blocks/partnership-banner-block.viewModel';

export function PartnershipBannerBlockView({
  hide,
  title,
  isH1,
  theme,
  display,
  buttonLink,
  items
}: PartnershipBannerBlockViewModel) {
  return hide ? null : (
    <CMSBlockWrapper contentClassName={css.content({ theme })}>
      <CMSBlockTitle
        titleTag={isH1 ? 'h1' : 'h2'}
        value={title}
        className={css.title}
      ></CMSBlockTitle>

      <div className={css.rightWrapper}>
        {display === 'horizontal' ? <div className={css.horizontalSeparator({ theme })} /> : null}

        <div className={css.rightContent}>
          {display === 'vertical' ? <div className={css.verticalSeparator({ theme })} /> : null}
          <div className={css.items}>
            {items.map((item, index) => (
              <div key={index} className={css.item}>
                <span className={css.itemTitle}>{(index + 1).toString().padStart(2, '0')}</span>
                <span className={css.itemBody}>{item}</span>
              </div>
            ))}
          </div>
          {display === 'vertical' ? <div className={css.verticalSeparator({ theme })} /> : null}
          <LinkButton href={buttonLink.uri} target={buttonLink.target}>
            {buttonLink.title}
          </LinkButton>
        </div>

        {display === 'horizontal' ? <div className={css.horizontalSeparator({ theme })} /> : null}
      </div>
    </CMSBlockWrapper>
  );
}
